import { IDepartmentRegistry, IDepartmentRepository } from "../../../domain/department";
import { DepartmentRepository } from ".";

export class DepartmentRegistry implements IDepartmentRegistry {
  constructor(private _getToken: () => string) {
  }

  getDepartmentRepository(): IDepartmentRepository {
    return new DepartmentRepository(this._getToken);
  }
}
